/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-accounting-tab-container',
  templateUrl: 'accounting-tab-container.component.html',
})
export class AccountingTabContainerComponent {

}
